<template>
  <nav
    class="page-nav"
  >
    <router-link
      v-for="route in tabsData"
      :key="route.slug"
      class="page-nav__link"
      active-class="page-nav__link--selected"
      :to="{path: `/${route.slug}`}"
    >
      {{ route.title }}
    </router-link>
  </nav>
</template>

<script>
import DSRouter from '../services/DSRouter'
export default {
  name: 'PageNav',
  mixins: [DSRouter.routerDataMixin],
  data() {
    return {
      tabsData: this.getRoutesData(),
    }
  },
}
</script>

<style lang="scss">
@import '../../app/assets/stylesheets/variables.scss';

.page-nav {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  border-bottom: 1px solid $grey-1;
  transition: color ease 200ms;
  top: 0;
  font-size: 1.4rem;

  @media (max-width: $desktop-width) {
    font-size: 1.2rem;
    overflow-x: scroll;
    position: sticky;
  }

  @media (max-width: $mobile-width) {
    font-size: 1rem;
    justify-content: left;
  }

  &__link {
    padding: 1.5em;
    text-align: center;

    @media (max-width: $desktop-width) {
      padding: 1em 1.5em;
    }

    @media (max-width: $mobile-width) {
      padding: 1em 1.1em;
    }

    color: transparentize(#000, 0.5);

    &:hover,
    &:active {
      color: transparentize(#000, 0.1);
    }

    &--selected {
      color: transparentize(#000, 0);
      box-shadow: inset 0 -4px 0 -1px $purple-1;
    }
  }
}
</style>
